<template>
  <section id="services" class="services">
    <h1>{{ $t('DStudioServicesTitle') }}</h1>
    <div class="body">
      <CardClassic>
        <h3>{{ $t('DStudioServicesCard1Title') }}</h3>
        <p>{{ $t('DStudioServicesCard1Subtitle1') }}</p>
        <h4>{{ $t('DStudioServicesCard1Subtitle3') }}</h4>
        <UiToolTipInfo
          leftPosition="165px"
          maxWitdthTooltip="400px"
          tooltipText="DStudioTooltipSection3GalleryHiddenText"
          ><span class="hidden-text">{{
            $t('DStudioTooltipSection3Gallery')
          }}</span></UiToolTipInfo
        >
      </CardClassic>
      <CardClassic>
        <UiSliderV3 :items="sliderItems" />
      </CardClassic>
    </div>
    <ui-button
      class="services__btn"
      @click="actionHandler"
      :color="'primary-offer'"
      :size="ButtonSizeType.b_l"
    >
      {{ $t('orderDesign') }}
    </ui-button>
  </section>
</template>

<script setup lang="ts">
import {ButtonSizeType} from '~/interfaces/ui/button';
import {useDesignStudioStore} from '~/store/design-studio.store';
import {useRoute} from "vue-router";
import {getLocaleFromPath} from '~/helpers/getLocaleFromPath';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const designStudio = useDesignStudioStore();

const route = useRoute();
const localeFromPath = getLocaleFromPath(route.fullPath);
const emits = defineEmits(['designRequest']);

const actionHandler = () => {
  if (route.path.includes('d-studio')) {
    designStudio.btnCreateHandlerForLanding();
  } else {
    emits('designRequest');
  }
};

const sliderItems = [
  {
    id: 1,
    title: 'DStudioServicesGallery1Title',
    subtitle: 'DStudioServicesGallery1Subtitle',
    type: 'images',
    items: [
      {
        src: `${staticUrl}/images/design-studio/ds-gallery-1.png`,
      },
      {
        src: `${staticUrl}/images/design-studio/ds-gallery-1-2.png`,
      },
      {
        src: `${staticUrl}/images/design-studio/ds-gallery-1-3.png`,
      },
      {
        src: `${staticUrl}/images/design-studio/ds-gallery-1-4.png`,
      },
    ],
  },
  {
    id: 2,
    title: 'DStudioServicesGallery2Title',
    subtitle: 'DStudioServicesGallery2Subtitle',
    type: 'video',
    items: [
      {
        src: `${staticUrl}/video/ds-studio-gallery-1.mp4`,
        srcMobile: `${staticUrl}/video/ds-studio-gallery-1_mobile.mp4`,
      },
      {
        src: `${staticUrl}/video/ds-studio-gallery-2.mp4`,
        srcMobile: `${staticUrl}/video/ds-studio-gallery-2.mp4`,
      },
    ],
  },
  {
    id: 3,
    title: 'DStudioServicesGallery3Title',
    subtitle: 'DStudioServicesGallery3Subtitle',
    type: 'tour',
    items: [
      {src: '/tours/Tour_from_06.03.2024_19-32-12-166/index.htm?n=1'},
    ],
  },
  {
    id: 4,
    title: 'DStudioServicesGallery4Title',
    subtitle: 'DStudioServicesGallery4Subtitle',
    type: 'specif',
    items: [
      {
        src: localeFromPath ==='ru' ? `${staticUrl}/pdf/ds-specif.pdf` : `${staticUrl}/pdf/ds-specif-en.pdf`,
      },
    ],
  },
];
</script>

<style scoped lang="scss">
.services {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: $m-45;

  &__btn {
    margin: auto;
    margin-top: $m-10;
    max-width: fit-content;
    width: 100%;
  }

  .body {
    display: flex;
    flex-direction: column;
    gap: $g-8;
    margin-top: $m-12;

    .hidden-text {
      @include launcher-p1;
      color: var(--var-black-200);
    }

    .tooltip {
      margin-top: $m-4;
      max-width: 400px;
    }

    .card-classic {
      align-items: unset;
      h3 {
        @include headline-h3;
        margin: 0px;
        margin-bottom: $m-1;
        color: var(--var-black-100);
      }
      p {
        @include launcher-p1;
        color: var(--var-black-200);
        margin: 0px;
        margin-top: $m-3;
      }
      h4 {
        @include launcher-p1;
        font-weight: $fw-600;
        color: var(--var-black-100);
        margin: 0px;
        margin-top: $m-3;
      }
    }

    @media (max-width: $md) {
      margin-top: $m-2;
    }
  }

  @media (min-width: 2000px) {
    min-height: unset;
  }
  @media (max-width: $lg) {
    width: 100%;
  }
  @media (max-width: $md) {
    gap: $g-5;
    margin-top: $m-40;
  }

  h1 {
    @include title-fw-700-fs-56-black-100;
    margin: 0px;
  }
}
</style>
